document.addEventListener("DOMContentLoaded", function() {
    let buttons = document.querySelectorAll(".size-option");
    let sizeInput = document.getElementById("selected-size");
    let addToCartButton = document.querySelector("form[action*='/cart/add'] button[type='submit']");

    if (buttons.length > 0) {
        buttons.forEach(button => {
            button.addEventListener("click", function() {
                buttons.forEach(btn => btn.classList.remove("active"));
                this.classList.add("active");

                let selectedVariantId = this.getAttribute("data-value");
                if (sizeInput) {
                    sizeInput.value = selectedVariantId;
                }

                // Asegurarse de que el botón "Agregar al carrito" tenga la variante correcta
                if (addToCartButton) {
                    addToCartButton.setAttribute("data-variant-id", selectedVariantId);
                }
            });
        });
    }
});
